module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIGhlaWdodD0iNTEyIiB3aWR0aD0iNTEyIiB2aWV3Qm94PSIwIDAgNTEyIDUxMiI+CiAgPGcgZmlsbC1ydWxlPSJldmVub2RkIj4KICAgIDxwYXRoIGZpbGw9IiNmZmYiIGQ9Ik0xNzAuMyAwaDE3MS4xNnY1MTEuOTg0SDE3MC4zeiIvPgogICAgPHBhdGggZmlsbD0icmVkIiBkPSJNMCAwaDE3MC4zdjUxMS45ODRIMHpNMzQwLjEzMiAwaDE3MS44NjF2NTExLjk4NEgzNDAuMTMyeiIvPgogIDwvZz4KPC9zdmc+Cg=="


//////////////////
// WEBPACK FOOTER
// ./~/flag-icon-css/flags/1x1/pe.svg
// module id = ./node_modules/flag-icon-css/flags/1x1/pe.svg
// module chunks = 0